/** Seat pack counts offered in Paystack (monthly + yearly). Keep in sync with BE. */
export const SEATS_PLAN_PACK_COUNTS = [5, 10, 20, 30, 50, 100, 200, 400, 1000] as const;

/** Paystack pack "1000" is sold as unlimited seats in-app. */
export const SEATS_UNLIMITED_PACK_COUNT = 1000;

/** Stored maxStaff when the unlimited (1000) seats pack is active. */
export const SEATS_UNLIMITED_MAX_STAFF = 999999;

/** Parse "User Seats (for N) …" pack size from a Paystack plan title. */
export const parseSeatsPackCountFromTitle = (title: string): number => {
  const m = String(title || '').match(/\(for\s+(\d+)\)/i);
  if (m) return Number(m[1]);
  return +(String(title || '').replace(/\D/g, '')) || 0;
};

/** maxStaff entitlement from a seats plan title (1000 pack → 999999). */
export const resolveMaxStaffFromSeatsPlanTitle = (title: string): number => {
  const pack = parseSeatsPackCountFromTitle(title);
  if (pack === SEATS_UNLIMITED_PACK_COUNT) return SEATS_UNLIMITED_MAX_STAFF;
  return pack > 0 ? pack : 0;
};

export const isUnlimitedSeatsMax = (maxStaff: number | null | undefined): boolean => (
  Number(maxStaff) >= SEATS_UNLIMITED_MAX_STAFF
);

/** UI label for a seats pack count or stored maxStaff. */
export const formatSeatsCapacityLabel = (seatsOrMax: number): string => {
  if (seatsOrMax === SEATS_UNLIMITED_PACK_COUNT || isUnlimitedSeatsMax(seatsOrMax)) {
    return 'Unlimited';
  }
  return Number(seatsOrMax || 0).toLocaleString();
};
